import React from "react";
import toast from "react-hot-toast";
import { GET_IMAGE } from "../../helpers/images";
import { FONT } from "../../pages/Feed/feedTokens";
import { getNotificationTitle, getNotiVisual } from "../../helpers/notifications";
import blankPic from "../../img/blankPic.png";

/**
 * The real-time "popout" for a freshly-arrived notification — rendered
 * top-right, next to the bell it's about. Mirrors the existing
 * ShareToast.jsx card pattern (rounded card, toast.custom, fade/slide driven
 * by t.visible, dismiss button) so it reads as part of the same design
 * system rather than a one-off alert style.
 */
function NotificationToastCard({ t, item, onClick }) {
  const visual = getNotiVisual(item);
  const Icon = visual.icon;
  const avatarSrc = item?.image ? GET_IMAGE(item.image) : blankPic;

  return (
    <div
      onClick={() => {
        onClick?.();
        toast.dismiss(t.id);
      }}
      style={{
        display: "flex",
        alignItems: "flex-start",
        gap: "12px",
        width: "336px",
        maxWidth: "88vw",
        background: "#FFFFFF",
        borderRadius: "16px",
        padding: "14px",
        boxShadow: "0 10px 28px -8px rgba(15,23,42,0.22), 0 2px 8px rgba(15,23,42,0.08)",
        border: "1px solid #F1F5F9",
        fontFamily: FONT,
        cursor: "pointer",
        opacity: t.visible ? 1 : 0,
        transform: t.visible ? "translateY(0)" : "translateY(-8px)",
        transition: "opacity 180ms ease, transform 180ms ease",
      }}
    >
      <div style={{ position: "relative", flexShrink: 0 }}>
        <img
          src={avatarSrc}
          alt=""
          style={{ width: "38px", height: "38px", borderRadius: "50%", objectFit: "cover", background: "#F1F5F9" }}
        />
        <div
          style={{
            position: "absolute",
            bottom: -3,
            right: -3,
            width: "20px",
            height: "20px",
            borderRadius: "50%",
            background: visual.bg,
            border: "2px solid #fff",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Icon sx={{ fontSize: 11, color: visual.color }} />
        </div>
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: "10px", fontWeight: 700, letterSpacing: "0.04em", textTransform: "uppercase", color: "#94A3B8" }}>
          New notification
        </div>
        <div style={{ fontSize: "13px", fontWeight: 700, color: "#0F172A", marginTop: "2px", lineHeight: 1.35 }}>
          {getNotificationTitle(item)}
        </div>
        <div style={{ fontSize: "11px", color: "#94A3B8", marginTop: "3px", fontWeight: 500 }}>Just now</div>
      </div>

      <button
        type="button"
        aria-label="Dismiss"
        onClick={(e) => {
          e.stopPropagation();
          toast.dismiss(t.id);
        }}
        style={{
          background: "transparent",
          border: "none",
          cursor: "pointer",
          color: "#CBD5E1",
          flexShrink: 0,
          padding: "2px",
        }}
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round">
          <path d="M18 6 6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
}

export function popNotificationToast(item, onClick) {
  return toast.custom((t) => <NotificationToastCard t={t} item={item} onClick={onClick} />, {
    position: "top-right",
    duration: 5000,
  });
}
